// extracted by mini-css-extract-plugin
export default {"form-control":"lkrDScjrbT2J5k_jjREf","isFullWidth":"FyZtn11xB5f16YImjENp"};